/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon20Regular = forwardRef('ArrowDUturnUpLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.514.179a.75.75 0 1 1 .972 1.142L5.04 4.25H11a6.75 6.75 0 0 1 0 13.5H6.75a.75.75 0 0 1 0-1.5H11a5.25 5.25 0 1 0 0-10.5H5.04l3.445 2.929a.75.75 0 0 1-.972 1.142l-3.88-3.297a2 2 0 0 1 0-3.048L7.515.18Z" })));
});
